import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer, Download } from "lucide-react";
import { api, fmtDate, fmtEuro, quoteFileName } from "@/lib/api";
import { LogoFull } from "@/components/Logo";
import { GoldButton, GhostButton } from "@/components/common";
import { downloadPdf } from "@/components/SupplierOrder";
import { TYPE_LABEL } from "@/pages/Quotes";

export default function QuotePrint() {
  const { id } = useParams();
  const [q, setQ] = useState(null);
  useEffect(() => { api.get(`/quotes/${id}`).then((r) => { setQ(r.data); document.title = `Preventivo ${r.data.number} - Estetica e Benessere`; }); }, [id]);
  if (!q) return null;

  return (
    <div className="min-h-screen bg-[#F6F1EA] print:bg-white py-10 print:py-0" data-testid="quote-print-page">
      <div className="mx-auto mb-6 flex max-w-3xl justify-end px-4 print:hidden">
        <GoldButton onClick={() => downloadPdf(`/quotes/${q.id}/pdf`, quoteFileName(q))} data-testid="quote-download-pdf"><Download className="h-4 w-4" /> Scarica PDF</GoldButton>
        <GhostButton onClick={() => window.print()} data-testid="print-now-button"><Printer className="h-4 w-4" /> Stampa</GhostButton>
      </div>
      <div className="mx-auto max-w-3xl bg-[#FDFBF7] px-5 sm:px-10 py-12 shadow-[0_10px_30px_-10px_rgba(18,18,18,0.12)] print:shadow-none print:max-w-none">
        <header className="flex flex-wrap items-start justify-between gap-4 border-b border-[#C5A059]/50 pb-8">
          <LogoFull className="w-40 sm:w-64 rounded-xl" />
          <div className="text-right text-sm">
            <div className="text-xs uppercase tracking-[0.2em] text-[#C5A059]">Preventivo</div>
            <div className="font-mono text-[#121212]" data-testid="print-quote-number">{q.number}</div>
            <div className="text-[#6E675F]">{fmtDate(q.created_at)}</div>
          </div>
        </header>
        <section className="mt-8 flex justify-between gap-6 text-sm">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#6E675F]">Gentile cliente</div>
            <div className="mt-1 font-serif text-2xl text-[#121212]" data-testid="print-client-name">{q.client_name}</div>
          </div>
          <div className="text-right">
            <div className="text-xs uppercase tracking-[0.2em] text-[#6E675F]">Proposta</div>
            <div className="mt-1 text-[#121212]">{q.title || TYPE_LABEL[q.type]}</div>
            {q.valid_until && <div className="text-[#6E675F]">Valido fino al {fmtDate(q.valid_until)}</div>}
          </div>
        </section>
        <table className="mt-10 w-full text-sm">
          <thead>
            <tr className="border-b border-[#121212] text-left text-xs uppercase tracking-[0.14em] text-[#6E675F]">
              <th className="py-2 font-normal">{q.type === "laser" ? "Zona" : "Trattamento"}</th>
              <th className="py-2 text-center font-normal">Sedute</th>
              <th className="py-2 text-right font-normal">€ a seduta</th>
              <th className="py-2 text-right font-normal">Importo</th>
            </tr>
          </thead>
          <tbody>
            {q.items.map((i, k) => (
              <tr key={k} className="border-b border-[#E8E1D7]">
                <td className="py-3 text-[#121212]">{i.description}</td>
                <td className="py-3 text-center">{i.sessions}</td>
                <td className="py-3 text-right">{fmtEuro(i.unit_price)}</td>
                <td className="py-3 text-right">{fmtEuro(i.unit_price * i.sessions)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="ml-auto mt-6 w-64 space-y-2 text-sm">
          <div className="flex justify-between"><span className="text-[#6E675F]">Subtotale</span><span>{fmtEuro(q.subtotal)}</span></div>
          {q.discount_amount > 0 && <div className="flex justify-between text-[#8A6A22]"><span>Sconto {q.discount_percent}%</span><span>− {fmtEuro(q.discount_amount)}</span></div>}
          <div className="flex justify-between border-t border-[#C5A059] pt-2"><span className="font-serif text-xl">Totale</span><span className="font-serif text-2xl" data-testid="print-total">{fmtEuro(q.total)}</span></div>
        </div>
        {q.notes && <p className="mt-10 whitespace-pre-line text-sm text-[#6E675F]">{q.notes}</p>}
        <footer className="mt-16 flex justify-between text-xs text-[#9E958A]">
          <span>Firma per accettazione ______________________</span>
          <span>Estetica e Benessere</span>
        </footer>
      </div>
    </div>
  );
}
